import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { BarChart2, ChevronRight } from 'lucide-react';

const CurvaABCWidget = () => {
  const navigate = useNavigate();
  const ano = new Date().getFullYear();
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    api.get(`/dashboard/curva-abc?ano=${ano}`)
      .then(res => setClientes(res.data || []))
      .catch(() => setErro(true))
      .finally(() => setLoading(false));
  }, [ano]);

  const contA = clientes.filter(c => c.classificacao === 'A').length;
  const contB = clientes.filter(c => c.classificacao === 'B').length;
  const contC = clientes.filter(c => c.classificacao === 'C').length;

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-blue-50 rounded-lg flex items-center justify-center">
            <BarChart2 size={16} className="text-[#0A3D73]" />
          </div>
          <div>
            <p className="text-sm font-black text-slate-800">Curva ABC — Clientes</p>
            <p className="text-xs text-slate-400">Faturamento acumulado {ano}</p>
          </div>
        </div>
        <button onClick={() => navigate('/inteligencia-comercial')}
          className="flex items-center gap-1 text-xs font-black text-[#0A3D73] hover:opacity-70 transition-opacity">
          Ver detalhes <ChevronRight size={11} />
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-6">
          <div className="w-6 h-6 border-4 border-slate-200 border-t-[#0A3D73] rounded-full animate-spin" />
        </div>
      ) : erro ? (
        <div className="flex items-center justify-center py-6">
          <p className="text-sm text-red-500 font-semibold">Erro ao carregar dados</p>
        </div>
      ) : clientes.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-6 gap-1">
          <p className="text-sm font-black text-slate-500">Sem dados de faturamento</p>
          <p className="text-xs text-slate-400">Nenhuma NF emitida em {ano}</p>
        </div>
      ) : (
        <div className="px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="flex-1 text-center bg-emerald-50 border border-emerald-200 rounded-lg py-3">
              <p className="text-2xl font-black text-emerald-600">{contA}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-emerald-500 mt-0.5">Classe A</p>
            </div>
            <div className="flex-1 text-center bg-amber-50 border border-amber-200 rounded-lg py-3">
              <p className="text-2xl font-black text-amber-600">{contB}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-amber-500 mt-0.5">Classe B</p>
            </div>
            <div className="flex-1 text-center bg-red-50 border border-red-200 rounded-lg py-3">
              <p className="text-2xl font-black text-red-600">{contC}</p>
              <p className="text-[10px] font-black uppercase tracking-wide text-red-400 mt-0.5">Classe C</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CurvaABCWidget;
